<div id="dialog_container" class="small-dialog-container">
  <div id="upper_band" class="upper-band upper-band-color"></div>
  <div id="middle_band" class="center-band center">
    <img
      id="exclamation_icon"
      src="/assets/images/user.svg"
      alt="Exclamation"
      width="100"
      class="image-icon" />
    <span class="text-content">
      <div id="title" class="title">Updating your account manager</div>
      <div id="message" class="message">This won't take long!</div>
      <div id="dynamic_mesage" class="dynamic-text">{{ activeStatement() }}</div>
    </span>
  </div>
  <hr class="custom-hr" />
  <div id="lower_band" class="lower-band">
    <div id="loading_status" class="loading-status">
      <mat-progress-bar mode="indeterminate"> </mat-progress-bar>
    </div>
  </div>
</div>
